import { Paper, Grid, Typography, Skeleton } from '@mui/material';
import * as React from 'react';
import { formatDate } from '../../../../../shared/LanguageService';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

interface IProps {
    selectedForecasts: any[];
    city: string;
    labels: ForecastWidgetLabels;
}

type ForecastWidgetLabels = {
    noWeatherInfo: string;
};

let ForecastWrapper = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    boxShadow: 'none',
    minHeight: '72px',
    paddingLeft: '8px'
}));

export const Forecast = ({ forecast, hour }) => {
    const [iconNotAvailable, setIconNotAvailable] = React.useState(false);
    return (
        <Grid
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0px 8px 0px 8px'
            }}
        >
            {' '}
            <Typography sx={{ fontSize: '12px', fontFamily: 'Roboto', lineHeight: '19px' }}>
                {hour}
            </Typography>
            {!iconNotAvailable ? (
                <img
                    alt="sky icon"
                    style={{ width: 'auto', height: '24px' }}
                    src={forecast.skyIcon}
                    onError={() => setIconNotAvailable(true)}
                />
            ) : (
                <Skeleton variant={'circular'} sx={{ width: '24px', height: '24px' }} />
            )}
            <Typography
                sx={{
                    fontSize: '12px',
                    fontFamily: 'Roboto',
                    lineHeight: '19px',
                    whiteSpace: 'nowrap'
                }}
            >
                {forecast.precipitation} mm
            </Typography>
        </Grid>
    );
};
const ForecastWidget = (props: IProps) => {
    let { city, selectedForecasts, labels } = props;

    return (
        <>
            <ForecastWrapper>
                {selectedForecasts.length > 0 ? (
                    selectedForecasts.map((forecast, index) => {
                        let hour = formatDate(new Date(forecast.time.replace('Z', '')), 'HH:mm');
                        return <Forecast key={index} forecast={forecast} hour={hour} />;
                    })
                ) : (
                    <Box sx={{ paddingRight: '8px', textAlign: 'center' }}>
                        <Typography sx={{ whiteSpace: 'break-spaces' }}>
                            {labels.noWeatherInfo}
                        </Typography>
                    </Box>
                )}
            </ForecastWrapper>
            {city ? (
                <Grid sx={{ marginTop: '8px' }}>
                    <Typography sx={{ fontSize: '10px', fontWeight: 400 }}>
                        <LocationOnIcon sx={{ height: '9px' }} />
                        {city}
                    </Typography>
                </Grid>
            ) : null}
        </>
    );
};

export default ForecastWidget;
